<template>
  <!-- SIDE MENU -->
  <nav class="panel sidepanel">
    <p class="panel-heading">
      {{header}}
    </p>

    <div class="div-overflow" v-for="(item, index) in items" :key="index">
      <a class="panel-block" v-bind:class="{'is-active': selectedItemId == item.id}" v-on:click="elementClick(item.id)" v-bind:title="item.name">    
        {{ item.name }}
      </a>
    </div>
  </nav>
  <!-- END SIDE MENU -->
</template>

<script>
export default {
  name: "side-menu",
  props: {
    header: String,
    items: Array,
    selectedItemId: Number
  },
  data() {
    return {
      selectedItemIdPriv: -1 // for indication
    };
  },
  methods: {
    elementClick(id) {
      this.$emit("elementClick", id);
    }
  },
  // computed: {
  //   selectedItemId: {
  //     get: function() {
  //       if (this.selectedItemIdPriv == -1) {
  //         return this.items[0].id;
  //       } else {
  //         return this.selectedItemIdPriv;
  //       }
  //     },
  //     set: function(newVal) {
  //       this.selectedItemIdPriv = newVal;
  //     }
  //   }
  // }
};
</script>

<style>
.panel-block.is-active {
  font-weight:500;
  border-left-width: 5px;
  }
.sidepanel {
  background-color: #fafafa;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
/* .div-overflow {
  overflow:hidden;
} */
.div-overflow a {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.Vue